// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorFallback_wrapper__+3rlR","error":"ErrorFallback_error__+0o3s"};